import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/analytics')({
  head: () => ({
    meta: [{ title: 'Analytics | Tekst' }],
  }),
  component: () => <Outlet />,
});
